var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"coin",attrs:{"data-cy":_vm.dataCy}},[_vm._v("\n  "+_vm._s(_vm.faceValue)+"\n  "),_vm._t("icon")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }